import { Outlet, useLocation, useNavigate } from "react-router-dom";
import AsideBar from "../components/AsideBar";
import { hasMenuAccess, menuKeyWithPath } from "../lib/utils";
import { useEffect } from "react";

function LayoutOutlet() {
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();
  let hide = [
    "/",
    "/login-otp",
    "/signup",
    "/signup-otp",
    "/social/login",
    "/add-workspace",
    "/guides/smtp-setup",
    "/guides/gmail-setup",
    "/guides/outlook-setup",
  ];
  const noPaddingRoutes = [
    "/person-level-id",
    "/company-level-id",
    "/unauthorized",
  ]; // Routes that don't need wrapper-setting padding

  const displayAsideBar = () => {
    if (hide.includes(pathname)) {
      return false;
    }
    return true;
  };

  const shouldRemovePadding = () => {
    return noPaddingRoutes.includes(pathname);
  };

  useEffect(() => {
    //using menuKeyWithPath to check if the current path includes any of the paths in the array
    const matchedMenu = menuKeyWithPath.find((menu) =>
      Object.values(menu).some((path) => pathname.includes(path))
    );

    if (matchedMenu) {
      const menuKey = Object.keys(matchedMenu)[0];
      // Check if user has access to the matched menu
      if (!hasMenuAccess(menuKey)) {
        navigate("/unauthorized");
      }
    }
  }, [pathname]);

  return (
    <>
      {displayAsideBar() && <AsideBar></AsideBar>}
      <div
        className={
          shouldRemovePadding()
            ? "wrapper-setting-no-padding"
            : "wrapper-setting"
        }
        style={{
          marginLeft: !displayAsideBar() && "0px",
          paddingTop: !displayAsideBar() && "0px",
        }}
      >
        <Outlet></Outlet>
      </div>
    </>
  );
}
export default LayoutOutlet;
